import type { ReactNode } from "react";
import { cn } from "./cn";

export function Eyebrow({
  n,
  children,
  light,
}: {
  n?: string;
  children: ReactNode;
  light?: boolean;
}) {
  return (
    <div
      className={cn(
        "font-mono text-[11px] uppercase tracking-[0.3em] leading-snug break-words",
        light ? "text-accent-deep" : "text-accent",
      )}
    >
      [ {n ? `${n} · ` : null}
      {children} ]
    </div>
  );
}
